import { render, staticRenderFns } from "./youtube-delivery.vue?vue&type=template&id=c40c469e&scoped=true"
import script from "./youtube-delivery.vue?vue&type=script&lang=js"
export * from "./youtube-delivery.vue?vue&type=script&lang=js"
import style0 from "./youtube-delivery.vue?vue&type=style&index=0&id=c40c469e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c40c469e",
  null
  
)

export default component.exports